module.exports = __webpack_public_path__ + "img/ic_mpe_footsock_normal.63d962fa.png";